import "core-js/modules/es.promise.js";
import { prepareApi, voidify } from '../../utils';
prepareApi(['bcz_system']);
var noop = function noop() {
  // do nothing
};
/**
 * 给客户端导航栏中的分享按钮添加点击事件回调函数
 * @param fn 要执行的回调函数（传入 false 表示 NOOP）
 */
export function whenGlobalShareClicked(fn) {
  return new Promise(function (resolve) {
    // `fn` 如果是异步函数，返回值是 Promise。将 fn 直接赋值给 `onShareClick`，iOS 执行可能会报错
    window.bcz_system.onShareClick = fn === false ? noop : voidify(fn);
    resolve();
  });
}